import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { LoadingScreen } from "~/components/LoadingScreen";
import { ChargerPanel } from "~/components/mijn-laadpaal/ChargerPanel";
import { SessionsPanel } from "~/components/mijn-laadpaal/SessionsPanel";
import {
  accountsListQueryOptions,
  chargerDocumentsListQueryOptions,
  chargersListQueryOptions,
  contractTypesQueryOptions,
  currentContractQueryOptions,
  ensureDefaultSessionYear,
  ereRateQueryOptions,
  profileQueryOptions,
  providersListQueryOptions,
  sessionUploadLimitQueryOptions,
} from "~/lib/api";

export const Route = createFileRoute("/(authenticated)/_app/mijn-laadpaal/")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { connect?: string; error?: string } => ({
    connect: (search.connect as string) || undefined,
    error: (search.error as string) || undefined,
  }),
  loader: async ({ context }) => {
    const qc = context.queryClient;
    await Promise.all([
      qc.ensureQueryData(chargersListQueryOptions()),
      qc.ensureQueryData(providersListQueryOptions()),
      qc.ensureQueryData(accountsListQueryOptions()),
      ensureDefaultSessionYear(qc),
      qc.ensureQueryData(profileQueryOptions()),
      qc.ensureQueryData(ereRateQueryOptions()),
      qc.ensureQueryData(currentContractQueryOptions()),
      qc.ensureQueryData(contractTypesQueryOptions()),
      qc.ensureQueryData(chargerDocumentsListQueryOptions("sessions")),
      qc.ensureQueryData(sessionUploadLimitQueryOptions()),
    ]);
  },
  pendingComponent: LoadingScreen,
  component: MijnLaadpaal,
});

function MijnLaadpaal() {
  const { connect, error } = Route.useSearch();

  return (
    <div className="mx-auto max-w-6xl p-5 pt-10 lg:p-10">
      <div className="mb-8">
        <h1 className="text-3xl font-medium lg:text-4xl">Mijn laadpaal</h1>
        <p className="text-muted-foreground mt-1.5 text-sm lg:text-base">
          Je laadpalen staan gegroepeerd per koppeling. Synchroniseer een koppeling om
          nieuwe laadpalen op te halen, en bekijk al je laadsessies op één plek.
        </p>
      </div>

      <div className="flex flex-col gap-12">
        <Suspense>
          <ChargerPanel
            oauthReturn={connect ? { providerId: connect, error } : undefined}
          />
        </Suspense>
        <Suspense>
          <SessionsPanel />
        </Suspense>
      </div>

      <p className="text-muted-foreground mt-10 text-sm">
        Werkt je koppeling niet? Neem contact op met onze{" "}
        <a
          className="text-foreground cursor-pointer underline underline-offset-4"
          onClick={() => window.$crisp?.push(["do", "chat:open"])}
        >
          klantenservice
        </a>{" "}
        en we helpen je verder.
      </p>
    </div>
  );
}
